function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#59A315"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.15,
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.5 27.5l12 12.5c8.407-1.423 15.577-7.529 17-16l-11-12.5-18 16z",
  fill: "#000"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 12,
  fill: "#FFFCF2"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M18.738 25.22c-.473.481-1.239.481-1.712 0l-3.707-3.785a1.26 1.26 0 01.036-1.714c.472-.48 1.24-.48 1.712 0l2.815 2.878 7.05-7.239c.474-.48 1.24-.48 1.713 0 .473.48.473 1.263 0 1.75 0 0-7.748 7.945-7.907 8.11z",
  fill: "#59A315"
});
function SvgDashboardCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}
export default __webpack_public_path__ + "fonts/dashboard-completed-69c7af2b445664d288d682c99e0e9397.svg";
export { SvgDashboardCompleted as ReactComponent };